import { ThemeProvider } from '@mui/material/styles'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import reportWebVitals from 'reportWebVitals'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'

import App from 'App'
import { reduxStore, persistor } from 'store'
import theme from 'core/Theme'
import { ToastProvider } from 'contexts'

import './index.css'
import { I18nextProvider } from 'react-i18next'
import i18n from 'translations/i18n'
import { Authenticator } from '@aws-amplify/ui-react'

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

const container = document.getElementById('root')
const root = createRoot(container!)
root.render(
  <React.StrictMode>
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_GG_RECAPTCHA_KEY as string}
    >
      <I18nextProvider i18n={i18n}>
        <Provider store={reduxStore}>
          <PersistGate persistor={persistor}>
            <ThemeProvider theme={theme}>
              <Authenticator.Provider>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <ToastProvider>
                    <App />
                  </ToastProvider>
                </LocalizationProvider>
              </Authenticator.Provider>
            </ThemeProvider>
          </PersistGate>
        </Provider>
      </I18nextProvider>
    </GoogleReCaptchaProvider>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
